// extracted by mini-css-extract-plugin
export var box = "box-module--box--4dfa4";
export var content = "box-module--content--9d577";
export var contentWrapper = "box-module--contentWrapper--731b6";
export var header = "box-module--header--d1d91";
export var labels = "box-module--labels--620d0";
export var logo = "box-module--logo--74a4f";
export var logoWrapper = "box-module--logoWrapper--1e63a";
export var quickfacts = "box-module--quickfacts--ca049";
export var quickfactsBox = "box-module--quickfactsBox--2a98c";